/**
 * 서비스 상태 값 상수.
 * @description
 * - `RESOLVED`: 정상
 * - `OPENED`: 확인 필요 (오늘 발생 가능)
 * - `PROCESSING`: 처리 중
 * - `ISSUE`: 과거 이슈 발생 (eventList 보유)
 */
export const ServiceStatus = {
  Resolved: 'RESOLVED',
  Opened: 'OPENED',
  Processing: 'PROCESSING',
  Issue: 'ISSUE',
} as const;

export type ServiceStatusType = (typeof ServiceStatus)[keyof typeof ServiceStatus];

export interface ServiceStatusEvent {
  eventId: string;
  eventTitle: string;
}

export interface ServiceStatusItem {
  date: string;
  eventList: ServiceStatusEvent[];
  status: ServiceStatusType;
}

export interface Service {
  serviceName: string;
  statusList: ServiceStatusItem[];
}

export interface ServiceStatusResponse {
  currentErrorServiceList: string[];
  serviceList: Service[];
}
